export const badgeInfo = {
  false: {
    gradientColor: "linear-gradient(92.42deg, #FDE7D9 0%, #FDECD9 100%)",
    teachingHours: "200",
    badgeDesc: "No information available. Badge not assigned",
  },
  CertifiedMentor: {
    gradientColor:
      "linear-gradient(92.42deg, #FDE4D8 0%, #FEF9EE 50%, #F9ECDC 100%)",
    teachingHours: "200",
    badgeDesc:
      "Recognized for Class Punctuality and Attendance throughout the Codeyoung tenure",
  },
  GrandmasterMentor: {
    gradientColor:
      "linear-gradient(92.42deg, #D2FDF7 0%, #EFEEFE 50%, #EDD6F7 100%)",
    teachingHours: "5,000",
    badgeDesc:
      "Recognized for leadership in mentoring, curriculum development, and impactful teaching",
  },
  SuperCertifiedMentor: {
    gradientColor:
      "linear-gradient(92.42deg, #D4D2FD 0%, #EFEEFE 50%, #D6F7F3 100%)",
    teachingHours: "1,250",
    badgeDesc:
      "Recognized for teaching excellence, punctuality, and active mentor community engagement",
  },
  MasterCertifiedMentor: {
    gradientColor:
      "linear-gradient(92.42deg, #D4D2FD 0%, #EEF1FE 50%, #F3D6F7 100%)",
    teachingHours: "3,000",
    badgeDesc:
      "Honored for subject expertise, class quality, and long-standing commitment to academic standards",
  },
  SeniorGrandmasterMentor: {
    gradientColor:
      "linear-gradient(92.42deg, #FDD2FA 0%, #F9EEFE 50%, #F7D6E0 100%)",
    teachingHours: "7,500",
    badgeDesc:
      "Celebrated for excellence in content refinement, process improvement, and mentor guidance",
  },
  SupremeGrandmasterMentor: {
    gradientColor:
      "linear-gradient(92.42deg, #FDEBD2 0%, #FCF0FA 50%, #DCF7D6 100%)",
    teachingHours: "10,000",
    badgeDesc:
      "Honored for shaping learning strategy, driving innovation, and leading the mentor community",
  },
};

export const DESKTOP_BREAKPOINT = 800;

// ===========================================================================
// Mentor payout dispute window (single source of truth).
// Evaluated for the PREVIOUS month's payout via day-of-month + hour.
// Change the values HERE ONLY to shift the window everywhere.
// Window: 5th 12:00 AM -> 6th 11:59 PM.
// ===========================================================================
export const DISPUTE_WINDOW = {
  START_DAY: 5, // window opens on this day at 12:00 AM
  END_DAY: 6, // window closes on this day at END_HOUR
  END_HOUR: 24, // exclusive: open while currentHour < END_HOUR (up to 11:59 PM)
  TOOLTIP_TEXT:
    "Disputes can only be raised from 5th 12:00 AM to 6th 11:59 pm of the month",
};

// Whether the dispute window is currently open, given today's day + hour.
export const isDisputeWindowOpen = (currentDay, currentHour) =>
  (currentDay >= DISPUTE_WINDOW.START_DAY && currentDay < DISPUTE_WINDOW.END_DAY) ||
  (currentDay === DISPUTE_WINDOW.END_DAY && currentHour < DISPUTE_WINDOW.END_HOUR);

// Whether the payout month being viewed can be disputed right now.
// Lives here rather than in payout.jsx because the dispute modal needs the same answer for the
// month it is showing — two copies of this would drift the moment one is edited.
export const getDisputeEligibility = (disputeMonthYear) => {
  const currentDate = new Date();
  const currentDay = currentDate.getDate();
  const currentHour = currentDate.getHours();
  const currentMonth = currentDate.getMonth();
  const currentYear = currentDate.getFullYear();
  const disputeMonth = disputeMonthYear.getMonth();
  const disputeYear = disputeMonthYear.getFullYear();

  const prevMonth = currentMonth === 0 ? 11 : currentMonth - 1;
  const prevYear = currentMonth === 0 ? currentYear - 1 : currentYear;

  const isCurrentMonth =
    disputeYear === currentYear && disputeMonth === currentMonth;

  const isPreviousMonth =
    disputeYear === prevYear && disputeMonth === prevMonth;

  if (isCurrentMonth) {
    return {
      isDisputeEnabled: false,
      isCurrentMonth: isCurrentMonth,
      tooltipText: "Dispute can only be raised for the previous month.",
    };
  }

  if (isPreviousMonth) {
    return {
      isDisputeEnabled: isDisputeWindowOpen(currentDay, currentHour),
      tooltipText: DISPUTE_WINDOW.TOOLTIP_TEXT,
    };
  }

  return {
    isDisputeEnabled: false,
    isCurrentMonth: isCurrentMonth,
    tooltipText: "Dispute window closed. Please contact support.",
  };
};

export const capitalizeWords = (str) =>
  str.replace(/\b\w/g, (char) => char.toUpperCase());

export const isReactNative = () => {
  const userAgent = navigator.userAgent.toLowerCase();
  if (
    userAgent.includes("wv") ||
    userAgent.includes("react-native") ||
    window.ReactNativeWebView !== undefined
  ) {
    return true;
  } else {
    return false;
  }
};
